import { useCookies } from "react-cookie";
import React from "react";
import "./CookieConsent.scss";

const CookieConsent = () => {
    const [cookies, setCookies] = useCookies(["cookieConsent"]);

    const giveCookieConsent = () => {
        setCookies("cookieConsent", true, { path: "/" });
    };

    return (
        <div className="cookie-consent">
            <p>
                We use cookies to enhance your user experience. By using our website, you agree to our use of cookies.{" "}
                <a href="/cookie-policy">Learn more.</a>
            </p>
            <button onClick={giveCookieConsent}>Accept Cookies</button>
        </div>
    );
};

export default CookieConsent;
